document.addEventListener("fishwishlist:loaded", () => {
    document.querySelectorAll('h2.atw-drawer__heading, h2.wishlists-drawer__heading')
        .forEach(h2 => {
        const h3 = document.createElement('h3');
        for (const attr of h2.attributes) {
            h3.setAttribute(attr.name, attr.value);
        }
        h3.innerHTML = h2.innerHTML; 
        h2.replaceWith(h3);
        });
});